/* Mystic general collection search/filter behavior.
   This fork supports broader collection filters than Filthy Cotton.
   See docs/mystic-collection-search-map.md before consolidating. */

(function () {
const initCollectionsCustomSearch = () => {
  /* =========================================================
   COLLECTIONS CUSTOM SEARCH + FILTERS
   ---------------------------------------------------------
   Handles:
   - Keyword search within collection products
   - Custom category/content filters
   - Conditional animal/gaming/spiritual filters
   - Custom color/tone filters
   - Custom size filter
   - Custom sort
========================================================= */

  const form = document.getElementById('CollectionsCustomSearchForm');
  const input = form?.querySelector('input[name="q"]');
  const grid = document.getElementById('ShopProductsGrid');
  const resetButton = document.getElementById('CollectionsResetFilters');

  if (!form || !input || !grid) return;
  if (form.dataset.collectionsCustomInitialized === 'true') return;
  form.dataset.collectionsCustomInitialized = 'true';

  const getPrefetchCache = () => {
  let cache = document.getElementById('CollectionsCustomPrefetchCache');

  if (!cache) {
    cache = document.createElement('div');
    cache.id = 'CollectionsCustomPrefetchCache';
    cache.hidden = true;
    cache.style.display = 'none';

    grid.after(cache);
  }

  return cache;
};

const getProductKey = item => {
  const link =
    item.querySelector('a[href*="/products/"]') ||
    item.querySelector('a[href]');

  return (
    link?.getAttribute('href') ||
    item.dataset.title ||
    item.textContent ||
    ''
  )
    .trim()
    .toLowerCase();
};

const getItems = () => [
  ...Array.from(grid.querySelectorAll('.shop__grid-item')),
  ...Array.from(getPrefetchCache().querySelectorAll('.shop__grid-item'))
];

const getCards = () =>
  getItems()
    .map(item => item.querySelector('product-card'))
    .filter(Boolean);

const originalOrderKeys = getItems()
  .map(item => getProductKey(item))
  .filter(Boolean);

  const dropdowns = Array.from(
  document.querySelectorAll('[data-collections-dropdown], [data-filthy-dropdown]')
);

  /* =========================================================
     NO RESULTS MESSAGE
  ========================================================= */

  const noResultsMessage = document.createElement('div');

  noResultsMessage.className = 'collections-custom-no-results-message';
  noResultsMessage.innerHTML = `
    <h2>Oopsie Doopsie!</h2>
    <p>Check the spelling, try another keyword, or reset filters to browse all products in this collection.</p>
  `;

  grid.after(noResultsMessage);

  /* =========================================================
     CONSTANTS
  ========================================================= */

  const KNOWN_SIZES = [
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  '2XL',
  '3XL',
  '4XL',
  '5XL'
];

const COLOR_FAMILY_ORDER = [
  'white',
  'black',

  'light grey',
  'grey',
  'dark grey',

  'cream',
  'tan',
  'brown',

  'light red',
  'red',
  'dark red',

  'light pink',
  'pink',
  'dark pink',

  'light orange',
  'orange',
  'dark orange',

  'yellow',

  'light green',
  'green',
  'dark green',

  'turquoise',

  'light blue',
  'blue',
  'dark blue',

  'light purple',
  'purple',
  'dark purple',

  'camo',
  'multi',
  'other'
];

const COLOR_FAMILY_HEX = {
  'black': '#0A0A0A',
  'white': '#FFFFFF',

  'dark grey': '#3A3A3A',
  'grey': '#808080',
  'light grey': '#D9D9D9',

  'brown': '#5E3D09',
  'tan': '#D2B48C',
  'cream': '#DEDACA',

  'dark red': '#8B0000',
  'red': '#E21919',
  'light red': '#F4A3A3',

  'dark pink': '#B03060',
  'pink': '#FF6BB3',
  'light pink': '#F8C8DC',

  'dark orange': '#BA5400',
  'orange': '#EF8A21',
  'light orange': '#FDBA74',

  'yellow': '#FFD52E',

  'dark green': '#355E3B',
  'green': '#4CAF50',
  'light green': '#93C47D',

  'turquoise': '#40E0D0',

  'dark blue': '#062263',
  'blue': '#157CC9',
  'light blue': '#9FC5E8',

  'dark purple': '#300A52',
  'purple': '#801FDB',
  'light purple': '#C9A0DC',

  'camo': '#4B5320',
  'multi': '#C9A0DC',
  'other': '#E5E5E5'
};

const darkenHex = (hex, amount = 0.25) => {
  const value = hex.replace('#', '');

  const r = parseInt(value.substring(0, 2), 16);
  const g = parseInt(value.substring(2, 4), 16);
  const b = parseInt(value.substring(4, 6), 16);

  const darken = channel =>
    Math.max(
      0,
      Math.floor(channel * (1 - amount))
    );

  return `rgb(${darken(r)}, ${darken(g)}, ${darken(b)})`;
};

const hexToRgb = hex => {
  const clean = (hex || '').replace('#', '').trim();

  if (clean.length !== 6) return null;

  const value = parseInt(clean, 16);

  return {
    r: (value >> 16) & 255,
    g: (value >> 8) & 255,
    b: value & 255
  };
};

const rgbToHsl = ({ r, g, b }) => {
  r /= 255;
  g /= 255;
  b /= 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const lightness = (max + min) / 2;
  let hue = 0;
  let saturation = 0;

  if (max !== min) {
    const delta = max - min;

    saturation =
      lightness > 0.5
        ? delta / (2 - max - min)
        : delta / (max + min);

    if (max === r) {
      hue = (g - b) / delta + (g < b ? 6 : 0);
    } else if (max === g) {
      hue = (b - r) / delta + 2;
    } else {
      hue = (r - g) / delta + 4;
    }

    hue *= 60;
  }

  return {
    h: hue,
    s: saturation * 100,
    l: lightness * 100
  };
};

const getReadableColorText = hex => {
  const rgb = hexToRgb(hex);

  if (!rgb) return '#1E1E1E';

  const linearize = channel => {
    const value = channel / 255;

    return value <= 0.03928
      ? value / 12.92
      : Math.pow((value + 0.055) / 1.055, 2.4);
  };

  const luminance =
    0.2126 * linearize(rgb.r) +
    0.7152 * linearize(rgb.g) +
    0.0722 * linearize(rgb.b);

  const hsl = rgbToHsl(rgb);
  const whiteContrast = 1.05 / (luminance + 0.05);
  const darkContrast = (luminance + 0.05) / 0.062;

  if (
    whiteContrast >= darkContrast ||
    (hsl.s > 45 && hsl.l < 58 && whiteContrast >= 2.8)
  ) {
    return '#FFFFFF';
  }

  return '#1E1E1E';
};

    const labelize = value =>
  value
    .toString()
    .trim()
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/(dark|light)([a-z])/i, '$1 $2')
    .replace(/\s+/g, ' ')
    .replace(/\b\w/g, letter => letter.toUpperCase());


let genreSubtypeFilterCache = null;

const normalizeGenreConfigValue = value =>
  (value || '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\s+/g, ' ');

const getGenreSubtypeFilters = () => {
  if (genreSubtypeFilterCache) {
    return genreSubtypeFilterCache;
  }

  const script = document.querySelector('[data-genre-filter-config]');

  if (!script) {
    console.error('[Collections Search] Missing genre-filter-config snippet.');
    genreSubtypeFilterCache = [];
    return genreSubtypeFilterCache;
  }

  try {
    const parsed = JSON.parse(script.textContent || '[]');

    if (!Array.isArray(parsed) || !parsed.length) {
      console.error('[Collections Search] genre-filter-config is empty or invalid.');
      genreSubtypeFilterCache = [];
      return genreSubtypeFilterCache;
    }

    genreSubtypeFilterCache = parsed
      .map(item => ({
        key: normalizeGenreConfigValue(item.key || ''),
        label: item.label || labelize(item.key || ''),
        genre: normalizeGenreConfigValue(item.genre || item.key || '')
      }))
      .filter(item => item.key && item.genre);

    return genreSubtypeFilterCache;
  } catch (error) {
    console.error('[Collections Search] Could not parse genre-filter-config.', error);
    genreSubtypeFilterCache = [];
    return genreSubtypeFilterCache;
  }
};

const getGenreSubtypeKeys = () =>
  getGenreSubtypeFilters().map(item => item.key);

const getGenreSubtypeByGenre = genre =>
  getGenreSubtypeFilters().find(item =>
    item.genre === normalizeGenreConfigValue(genre)
  );

  /* =========================================================
     FILTER STATE
  ========================================================= */

    const activeFilters = {
    query: '',
    category: '',
    content: '',
    genre: '',
    department: '',
    apparel: '',
    fit: '',
    aesthetic: '',
    services: '',
    color: [],
    tone: [],
    collection: '',
    textOnly: false,
    nsfw: false,
    emoji: false,
    size: '',
    sort: ''
  };

getGenreSubtypeKeys().forEach(key => {
  if (!(key in activeFilters)) {
    activeFilters[key] = '';
  }
});

const hasActiveGenreSubtypeFilter = () =>
  getGenreSubtypeKeys().some(key => Boolean(activeFilters[key]));

const clearGenreSubtypeFilters = () => {
  getGenreSubtypeKeys().forEach(key => {
    activeFilters[key] = '';
  });
};

const clearInactiveGenreSubtypeFilters = () => {
  const activeGenre = activeFilters.genre || activeFilters.content;
  const activeSubtype = getGenreSubtypeByGenre(activeGenre);

  getGenreSubtypeKeys().forEach(key => {
    if (!activeSubtype || key !== activeSubtype.key) {
      activeFilters[key] = '';
    }
  });
};

  const getOriginalOrderCards = () => {
  const cardMap = new Map();

  getCards().forEach(card => {
    const item = card.closest('.shop__grid-item');
    const key = getProductKey(item);

    if (key && !cardMap.has(key)) {
      cardMap.set(key, card);
    }
  });

  return originalOrderKeys
    .map(key => cardMap.get(key))
    .filter(Boolean);
};

const hasActiveCollectionsFilter = () =>
  Boolean(
    activeFilters.query ||
    activeFilters.category ||
    activeFilters.content ||
    activeFilters.genre ||
    hasActiveGenreSubtypeFilter() ||
    activeFilters.department ||
    activeFilters.apparel ||
    activeFilters.fit ||
    activeFilters.aesthetic ||
    activeFilters.services ||
    getActiveFilterValues('color').length ||
    getActiveFilterValues('tone').length ||
    activeFilters.collection ||
    activeFilters.textOnly ||
    activeFilters.nsfw ||
    activeFilters.emoji ||
    activeFilters.size
  );

  /* =========================================================
     CARD DATA HELPERS
  ========================================================= */

  const getTitle = card => {
  const item = card.closest('.shop__grid-item');

  return (
    item?.dataset.title ||
    card.dataset.title ||
    card.querySelector('.product-card__title')?.textContent ||
    ''
  )
    .trim()
    .toLowerCase();
};

    const normalizeColorFamilyValue = value =>
      (value || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/(dark|light)(grey|gray|red|pink|orange|green|blue|purple)/g, '$1 $2')
        .replace(/\s+/g, ' ');

    const splitMetafield = value =>
      (value || '')
        .toString()
        .split(',')
        .map(item => normalizeColorFamilyValue(item))
        .filter(Boolean);

    const getCategory = card => {
  const item = card.closest('.shop__grid-item');

  return (
    item?.dataset.category ||
    item?.dataset.fcCategory ||
    ''
  )
    .trim()
    .toLowerCase();
};

const getGenre = card => {
  const item = card.closest('.shop__grid-item');

  return splitMetafield(
    item?.dataset.genre ||
    item?.dataset.fcGenre ||
    ''
  );
};

const getSubtypeValues = (card, key) => {
  const item = card.closest('.shop__grid-item');

  if (!item || !key) return [];

  const normalizedKey = normalizeColorFamilyValue(key);
  const camelKey = normalizedKey.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
  const pascalKey = camelKey.charAt(0).toUpperCase() + camelKey.slice(1);

  return splitMetafield(
    item.dataset[camelKey] ||
    item.dataset[`fc${pascalKey}`] ||
    item.dataset[`filter${pascalKey}`] ||
    ''
  );
};

const hasSubtypeValues = (card, key) =>
  getSubtypeValues(card, key).length > 0;

  const getColorFamily = card => {
  const item = card.closest('.shop__grid-item');

  return splitMetafield(
    item?.dataset.colorFamily ||
    item?.dataset.fcColorFamily ||
    ''
  );
};

  const getColorTone = card => {
  const item = card.closest('.shop__grid-item');

  return splitMetafield(
    item?.dataset.colorTone ||
    item?.dataset.fcColorTone ||
    ''
  );
};

const getColorTonePairs = card => {
  const item = card.closest('.shop__grid-item');

  return (
  item?.dataset.colorTonePairs ||
  item?.dataset.fcColorTonePairs ||
  ''
)
    .toString()
    .split('||')
    .map(pair => {
      const parts = pair.split('::');

      return {
        family: normalizeColorFamilyValue(parts[0] || ''),
        tone: normalizeColorFamilyValue(parts[1] || '')
      };
    })
    .filter(pair => pair.family && pair.tone);
};

const getActiveFilterValues = key => {
  const value = activeFilters[key];

  if (Array.isArray(value)) {
    return value.map(item => normalizeColorFamilyValue(item)).filter(Boolean);
  }

  if (value) {
    return [normalizeColorFamilyValue(value)];
  }

  return [];
};

const isActiveFilterValue = (key, value) =>
  getActiveFilterValues(key).includes(normalizeColorFamilyValue(value));

const toggleActiveFilterValue = (key, value) => {
  const normalizedValue = normalizeColorFamilyValue(value);

  if (key !== 'color' && key !== 'tone') {
    activeFilters[key] =
      normalizeColorFamilyValue(activeFilters[key]) === normalizedValue ? '' : normalizedValue;
    return;
  }

  const values = getActiveFilterValues(key);

  activeFilters[key] = values.includes(normalizedValue)
    ? values.filter(item => item !== normalizedValue)
    : [...values, normalizedValue];
};

  const getCollection = card => {
  const item = card.closest('.shop__grid-item');

  return splitMetafield(
    item?.dataset.collection ||
    item?.dataset.fcCollection ||
    ''
  );
};

const getDepartment = card => {
  const item = card.closest('.shop__grid-item');

  return splitMetafield(
    item?.dataset.department ||
    item?.dataset.fcDepartment ||
    ''
  );
};

const getApparel = card => {
  const item = card.closest('.shop__grid-item');

  return splitMetafield(
    item?.dataset.apparel ||
    item?.dataset.fcApparel ||
    ''
  );
};

const getFit = card => {
  const item = card.closest('.shop__grid-item');

  return splitMetafield(
    item?.dataset.fit ||
    item?.dataset.fcFit ||
    ''
  );
};

const getAesthetic = card => {
  const item = card.closest('.shop__grid-item');

  return splitMetafield(
    item?.dataset.aesthetic ||
    item?.dataset.fcAesthetic ||
    ''
  );
};

const getServices = card => {
  const item = card.closest('.shop__grid-item');

  return splitMetafield(
    item?.dataset.services ||
    item?.dataset.fcServices ||
    ''
  );
};

  const getTextOnly = card => {
  const item = card.closest('.shop__grid-item');

  return (
    item?.dataset.textOnly ||
    item?.dataset.fcTextOnly
  ) === 'true';
};

  const getNsfw = card => {
  const item = card.closest('.shop__grid-item');

  return (
    item?.dataset.nsfw ||
    item?.dataset.fcNsfw
  ) === 'true';
};

  const getEmoji = card => {
  const item = card.closest('.shop__grid-item');

  return (
    item?.dataset.emoji ||
    item?.dataset.fcEmoji
  ) === 'true';
};

    const getContentTypes = card => {
  const genreValues = getGenre(card);

  if (genreValues.length) {
    return genreValues;
  }

  const contentTypes = [];

  getGenreSubtypeFilters().forEach(filter => {
    if (hasSubtypeValues(card, filter.key)) {
      contentTypes.push(filter.genre);
    }
  });

  if (getTextOnly(card)) contentTypes.push('text-only');
  if (getNsfw(card)) contentTypes.push('nsfw');
  if (getEmoji(card)) contentTypes.push('emoji');

  return contentTypes;
};

  const getCardOptions = card => {
    const item = card.closest('.shop__grid-item');

    if (!item) return [];

    return (item.dataset.options || '')
      .split(',')
      .map(value => value.trim())
      .filter(Boolean);
  };

  const getCardSizes = card =>
    getCardOptions(card)
      .filter(option => KNOWN_SIZES.includes(option.toUpperCase()))
      .map(option => option.toUpperCase());

  const getCardVariantMap = card => {
  const item = card.closest('.shop__grid-item');
  const script =
    card.querySelector('[data-fc-variant-map]') ||
    item?.querySelector('[data-fc-variant-map]');

  if (!script) return [];

  try {
    const variants = JSON.parse(script.textContent || '[]');
    return Array.isArray(variants) ? variants : [];
  } catch (error) {
    return [];
  }
};

const getVariantFamily = variant =>
  normalizeColorFamilyValue(
    variant.family ||
    variant.color_family ||
    variant.colorFamily ||
    variant.variant_color_family ||
    variant.variantColorFamily ||
    variant.option ||
    variant.option1 ||
    variant.color ||
    variant.title ||
    ''
  );

const getVariantTone = variant =>
  normalizeColorFamilyValue(
    variant.tone ||
    variant.color_tone ||
    variant.colorTone ||
    variant.variant_color_tone ||
    variant.variantColorTone ||
    ''
  );

const isColorToneSelectionTemporarilyUnavailable = (key, value) => {
  const normalizedValue = normalizeColorFamilyValue(value);

  if (key !== 'color' && key !== 'tone') return false;
  if (!isActiveFilterValue(key, normalizedValue)) return false;

  const selectedColors =
    key === 'color'
      ? [normalizedValue]
      : getActiveFilterValues('color');

  const selectedTones =
    key === 'tone'
      ? [normalizedValue]
      : getActiveFilterValues('tone');

  if (!selectedColors.length || !selectedTones.length) return false;

  const cardMatchesNonColorToneScope = card => {
    const title = getTitle(card);

    if (!titleMatches(title, activeFilters.query)) return false;
    if (activeFilters.category && getCategory(card) !== activeFilters.category) return false;

    const activeGenre = activeFilters.genre || activeFilters.content;

    if (activeGenre && !getContentTypes(card).includes(activeGenre)) return false;

    for (const filter of getGenreSubtypeFilters()) {
      if (
        activeFilters[filter.key] &&
        !getSubtypeValues(card, filter.key).includes(activeFilters[filter.key])
      ) {
        return false;
      }
    }

    if (activeFilters.department && !getDepartment(card).includes(activeFilters.department)) return false;
    if (activeFilters.apparel && !getApparel(card).includes(activeFilters.apparel)) return false;
    if (activeFilters.fit && !getFit(card).includes(activeFilters.fit)) return false;
    if (activeFilters.aesthetic && !getAesthetic(card).includes(activeFilters.aesthetic)) return false;
    if (activeFilters.services && !getServices(card).includes(activeFilters.services)) return false;
    if (activeFilters.collection && !getCollection(card).includes(activeFilters.collection)) return false;
    if (activeFilters.textOnly && !getTextOnly(card)) return false;
    if (activeFilters.nsfw && !getNsfw(card)) return false;
    if (activeFilters.emoji && !getEmoji(card)) return false;
    if (activeFilters.size && !getCardSizes(card).includes(activeFilters.size.toUpperCase())) return false;

    return true;
  };

  return !getCards().some(card => {
    if (!cardMatchesNonColorToneScope(card)) return false;

    const pairs = getColorTonePairs(card);

    if (pairs.length) {
      return pairs.some(pair =>
        selectedColors.includes(pair.family) &&
        selectedTones.includes(pair.tone)
      );
    }

    return getCardVariantMap(card).some(variant =>
      selectedColors.includes(getVariantFamily(variant)) &&
      selectedTones.includes(getVariantTone(variant))
    );
  });
};

  const getPrice = card => {
  const item = card.closest('.shop__grid-item');
  const datasetPrice = Number(item?.dataset.price || 0);

  if (datasetPrice) {
    return datasetPrice;
  }

  const text = card.querySelector('.product-card__price')?.textContent || '';
  const match = text.replace(/,/g, '').match(/[\d.]+/);

  return match ? parseFloat(match[0]) : 0;
};

  /* =========================================================
     TITLE MATCHING
  ========================================================= */

  const titleMatches = (title, query) => {
    if (!query) return true;

    const titleWords = title
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean);

    const queryWords = query
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean);

    return queryWords.every(queryWord =>
      titleWords.some(titleWord => titleWord.startsWith(queryWord))
    );
  };

  const queryMatchesCard = card => {
    if (!activeFilters.query) return true;

    const title = getTitle(card);
    const category = getCategory(card);

    return (
      titleMatches(title, activeFilters.query) ||
      titleMatches(category, activeFilters.query)
    );
  };

  /* =========================================================
     DROPDOWN HELPERS
  ========================================================= */

  const getDropdown = key =>
    dropdowns.find(dropdown => dropdown.dataset.filterKey === key);

  const setDropdownLabel = (key, value, label) => {
  const dropdown = getDropdown(key);
  if (!dropdown) return;

  const labelEl =
    dropdown.querySelector('[data-collections-dropdown-label]') ||
    dropdown.querySelector('[data-filthy-dropdown-label]');

  const button =
    dropdown.querySelector('[data-collections-dropdown-button]') ||
    dropdown.querySelector('[data-filthy-dropdown-button]');

  if (labelEl) labelEl.textContent = label;

  button?.classList.toggle('is-active', Boolean(value));

  dropdown.querySelectorAll('[data-value]').forEach(option => {
    option.classList.toggle('is-selected', option.dataset.value === value);
  });
};

  const closeDropdowns = () => {
  dropdowns.forEach(dropdown => {
    dropdown.classList.remove('is-open');

    const menu =
      document.querySelector(
        `[data-collections-dropdown-menu][data-menu-key="${dropdown.dataset.filterKey}"]`
      ) ||
      document.querySelector(
        `[data-filthy-dropdown-menu][data-menu-key="${dropdown.dataset.filterKey}"]`
      ) ||
      dropdown.querySelector('[data-collections-dropdown-menu]') ||
      dropdown.querySelector('[data-filthy-dropdown-menu]');

    if (menu) menu.hidden = true;
  });
};

  const positionMenu = (dropdown, menu) => {
    if (!dropdown || !menu) return;

    const button =
  dropdown.querySelector('[data-collections-dropdown-button]') ||
  dropdown.querySelector('[data-filthy-dropdown-button]');
    if (!button) return;

    const padding = 16;

    menu.hidden = false;
    menu.style.width = 'max-content';
    menu.style.minWidth = '0';
    menu.style.maxWidth = `${window.innerWidth - padding * 2}px`;
    menu.style.transform = 'none';

    requestAnimationFrame(() => {
      const buttonRect = button.getBoundingClientRect();
      const menuRect = menu.getBoundingClientRect();

      let left =
        buttonRect.left + buttonRect.width / 2 - menuRect.width / 2;

      let top = buttonRect.bottom + 12;

      if (left < padding) left = padding;

      if (left + menuRect.width > window.innerWidth - padding) {
        left = window.innerWidth - padding - menuRect.width;
      }

      menu.style.left = `${left}px`;
      menu.style.top = `${top}px`;
    });
  };

  /* =========================================================
     DYNAMIC CUSTOM FILTER BUILDING
  ========================================================= */

  const ensureToneFilterRows = () => {
  document
    .querySelectorAll('[data-fc-filter-group="color"]')
    .forEach(colorGroup => {
      const parent = colorGroup.parentElement;

      if (!parent) return;
      if (parent.querySelector('[data-fc-filter-group="tone"]')) return;

      const toneGroup = colorGroup.cloneNode(true);

      toneGroup.setAttribute('data-fc-filter-group', 'tone');

      toneGroup
        .querySelectorAll('[data-fc-options="color"]')
        .forEach(menu => {
          menu.setAttribute('data-fc-options', 'tone');
          menu.innerHTML = '';
        });

      const label =
        toneGroup.querySelector('.sidebar-filters__filter-name') ||
        toneGroup.querySelector('.collapsible-row-list-item__title') ||
        toneGroup.querySelector('[data-sidebar-filter-title]') ||
        Array.from(toneGroup.querySelectorAll('*')).find(el =>
          el.children.length === 0 &&
          el.textContent.trim().toLowerCase() === 'color'
        );

      if (label) {
        label.textContent = 'Color Tone';
      }

      parent.insertBefore(toneGroup, colorGroup.nextSibling);
    });
};

  const buildCollectionsDynamicFilters = () => {
  ensureToneFilterRows();

  const selectedColors = getActiveFilterValues('color');
  const selectedTones = getActiveFilterValues('tone');

  const categories = new Set();
  const contentTypes = new Set();
  const departments = new Set();
  const apparel = new Set();
  const fits = new Set();
  const aesthetics = new Set();
  const services = new Set();
  const colors = new Set();
  const tones = new Set();
  const sizes = new Set();
  const collections = new Set();

  let hasCollections = false;
  let hasTextOnly = false;
  let hasNsfw = false;
  let hasEmoji = false;

  const TONE_ORDER = [
    'pastel',
    'muted',
    'classic',
    'vibrant',
    'deep'
  ];

  const getColorGroup = value => {
    const label = labelize(value);

    if ([
      'White',
      'Black',
      'Light Grey',
      'Grey',
      'Dark Grey',
      'Cream',
      'Tan',
      'Brown'
    ].includes(label)) return 'Neutrals';

    if ([
      'Light Red',
      'Red',
      'Dark Red',
      'Light Pink',
      'Pink',
      'Dark Pink',
      'Light Orange',
      'Orange',
      'Dark Orange',
      'Yellow'
    ].includes(label)) return 'Warms';

    if ([
      'Light Green',
      'Green',
      'Dark Green',
      'Turquoise',
      'Light Blue',
      'Blue',
      'Dark Blue',
      'Light Purple',
      'Purple',
      'Dark Purple'
    ].includes(label)) return 'Cools';

    if ([
      'Camo',
      'Multi',
      'Other'
    ].includes(label)) return 'Mixes';

    return '';
  };

  const cardMatchesOptionScope = (card, ignoredKey = '') => {
    if (!queryMatchesCard(card)) return false;

    if (
      ignoredKey !== 'category' &&
      activeFilters.category &&
      getCategory(card) !== activeFilters.category
    ) return false;

    const activeGenre =
      activeFilters.genre || activeFilters.content;

    if (
      ignoredKey !== 'content' &&
      ignoredKey !== 'genre' &&
      activeGenre &&
      !getContentTypes(card).includes(activeGenre)
    ) return false;

    for (const filter of getGenreSubtypeFilters()) {
      if (
        ignoredKey !== filter.key &&
        activeFilters[filter.key] &&
        !getSubtypeValues(card, filter.key).includes(activeFilters[filter.key])
      ) {
        return false;
      }
    }

    if (
      ignoredKey !== 'department' &&
      activeFilters.department &&
      !getDepartment(card).includes(activeFilters.department)
    ) return false;

    if (
      ignoredKey !== 'apparel' &&
      activeFilters.apparel &&
      !getApparel(card).includes(activeFilters.apparel)
    ) return false;

    if (
      ignoredKey !== 'fit' &&
      activeFilters.fit &&
      !getFit(card).includes(activeFilters.fit)
    ) return false;

    if (
      ignoredKey !== 'aesthetic' &&
      activeFilters.aesthetic &&
      !getAesthetic(card).includes(activeFilters.aesthetic)
    ) return false;

    if (
      ignoredKey !== 'services' &&
      activeFilters.services &&
      !getServices(card).includes(activeFilters.services)
    ) return false;

    if (
      ignoredKey !== 'collection' &&
      activeFilters.collection &&
      !getCollection(card).includes(activeFilters.collection)
    ) return false;

    if (
      ignoredKey !== 'textOnly' &&
      activeFilters.textOnly &&
      !getTextOnly(card)
    ) return false;

    if (
      ignoredKey !== 'nsfw' &&
      activeFilters.nsfw &&
      !getNsfw(card)
    ) return false;

    if (
      ignoredKey !== 'emoji' &&
      activeFilters.emoji &&
      !getEmoji(card)
    ) return false;

    if (
      ignoredKey !== 'size' &&
      activeFilters.size &&
      !getCardSizes(card).includes(activeFilters.size.toUpperCase())
    ) return false;

    if (
      ignoredKey !== 'color' &&
      selectedColors.length &&
      !selectedColors.some(color => getColorFamily(card).includes(color))
    ) return false;

    if (
      ignoredKey !== 'tone' &&
      selectedTones.length &&
      !selectedTones.some(tone => getColorTone(card).includes(tone))
    ) return false;

    return true;
  };

  const makeButton = (key, value) => {
    const normalizedValue = normalizeColorFamilyValue(value);
    const label = key === 'size'
      ? normalizedValue.toUpperCase()
      : labelize(normalizedValue);

      const temporarilyUnavailable =
  isColorToneSelectionTemporarilyUnavailable(key, normalizedValue);

    const colorHex =
      COLOR_FAMILY_HEX[normalizedValue] ||
      '#E5E5E5';

    const readableTextColor = getReadableColorText(colorHex);

    return `
      <button
        type="button"
        class="pill pill--small pill--outline fc-filter-option ${key === 'color' ? 'fc-color-pill' : ''} ${isActiveFilterValue(key, normalizedValue) ? 'selected' : ''} ${temporarilyUnavailable ? 'fc-temporarily-unavailable' : ''}"
        data-fc-filter="${key}"
        data-fc-value="${normalizedValue}"
        ${key === 'color' ? `data-fc-contrast="${readableTextColor === '#FFFFFF' ? 'light' : 'dark'}"` : ''}
        style="${
          key === 'color'
            ? `
              background-color: ${colorHex};
              border-color: ${darkenHex(colorHex, 0.28)};
              color: ${readableTextColor};
            `
            : ''
        }"
      >
        <span class="pill__label">${label}</span>
      </button>
    `;
  };

  const fillMenu = (selector, values, key) => {
    const menus = document.querySelectorAll(selector);

    menus.forEach(menu => {
      const group = menu.closest('[data-fc-filter-group]');

      menu.innerHTML = '';

      if (group) {
        group.hidden = values.length === 0;
      }

      let currentColorGroup = '';

      values.forEach(value => {
        if (key === 'color') {
          const colorGroup = getColorGroup(value);

          if (colorGroup && colorGroup !== currentColorGroup) {
            currentColorGroup = colorGroup;

            const heading = document.createElement('div');
            heading.className = 'fc-color-group-heading';
            heading.textContent = colorGroup;

            menu.appendChild(heading);
          }
        }

        menu.insertAdjacentHTML('beforeend', makeButton(key, value));
      });
    });
  };

  const allCards = getCards();

  allCards
    .filter(card => cardMatchesOptionScope(card, 'category'))
    .forEach(card => {
      const category = getCategory(card);
      if (category) categories.add(category);
    });

  allCards
    .filter(card => cardMatchesOptionScope(card, 'content'))
    .forEach(card => {
      getContentTypes(card).forEach(value => contentTypes.add(value));
    });

  allCards
    .filter(card => cardMatchesOptionScope(card, 'size'))
    .forEach(card => {
      getCardSizes(card).forEach(size => sizes.add(size.toLowerCase()));
    });

  allCards
    .filter(card => cardMatchesOptionScope(card, 'department'))
    .forEach(card => {
      getDepartment(card).forEach(value => departments.add(value));
    });

  allCards
    .filter(card => cardMatchesOptionScope(card, 'apparel'))
    .forEach(card => {
      getApparel(card).forEach(value => apparel.add(value));
    });

  allCards
    .filter(card => cardMatchesOptionScope(card, 'fit'))
    .forEach(card => {
      getFit(card).forEach(value => fits.add(value));
    });

  allCards
    .filter(card => cardMatchesOptionScope(card, 'aesthetic'))
    .forEach(card => {
      getAesthetic(card).forEach(value => aesthetics.add(value));
    });

  allCards
    .filter(card => cardMatchesOptionScope(card, 'services'))
    .forEach(card => {
      getServices(card).forEach(value => services.add(value));
    });

  allCards
    .filter(card => cardMatchesOptionScope(card, 'collection'))
    .forEach(card => {
      getCollection(card).forEach(value => {
        collections.add(value);
        hasCollections = true;
      });
    });

allCards
  .filter(card => cardMatchesOptionScope(card, 'color'))
  .forEach(card => {
    const pairs = getColorTonePairs(card);

    if (selectedTones.length && pairs.length) {
      pairs.forEach(pair => {
        if (selectedTones.includes(pair.tone)) {
          colors.add(pair.family);
        }
      });

      return;
    }

    getColorFamily(card).forEach(value => colors.add(value));
  });

  allCards
  .filter(card => cardMatchesOptionScope(card, 'tone'))
  .forEach(card => {
    const pairs = getColorTonePairs(card);

    const toneColorScope =
      selectedColors.length
        ? selectedColors
        : [...colors];

    if (toneColorScope.length && pairs.length) {
      pairs.forEach(pair => {
        if (toneColorScope.includes(pair.family)) {
          tones.add(pair.tone);
        }
      });

      return;
    }

    getColorTone(card).forEach(value => tones.add(value));
  });

  allCards
    .filter(card => cardMatchesOptionScope(card, 'textOnly'))
    .forEach(card => {
      if (getTextOnly(card)) hasTextOnly = true;
    });

  allCards
    .filter(card => cardMatchesOptionScope(card, 'nsfw'))
    .forEach(card => {
      if (getNsfw(card)) hasNsfw = true;
    });

  allCards
    .filter(card => cardMatchesOptionScope(card, 'emoji'))
    .forEach(card => {
      if (getEmoji(card)) hasEmoji = true;
    });

  fillMenu(
    '[data-fc-options="category"]',
    [...categories].sort(),
    'category'
  );

  fillMenu(
    '[data-fc-options="content"]',
    [...contentTypes].sort(),
    'content'
  );

  fillMenu(
    '[data-fc-options="genre"]',
    [...contentTypes].sort(),
    'genre'
  );

  getGenreSubtypeFilters().forEach(filter => {
    const values = new Set();

    allCards
      .filter(card => cardMatchesOptionScope(card, filter.key))
      .forEach(card => {
        getSubtypeValues(card, filter.key).forEach(value => {
          values.add(value);
        });
      });

    fillMenu(
      `[data-fc-options="${filter.key}"]`,
      [...values].sort(),
      filter.key
    );
  });

  fillMenu(
    '[data-fc-options="department"]',
    [...departments].sort(),
    'department'
  );

  fillMenu(
    '[data-fc-options="apparel"]',
    [...apparel].sort(),
    'apparel'
  );

  fillMenu(
    '[data-fc-options="fit"]',
    [...fits].sort(),
    'fit'
  );

  fillMenu(
    '[data-fc-options="aesthetic"]',
    [...aesthetics].sort(),
    'aesthetic'
  );

  fillMenu(
    '[data-fc-options="services"]',
    [...services].sort(),
    'services'
  );

  getActiveFilterValues('color').forEach(color => {
  colors.add(color);
});

fillMenu(
  '[data-fc-options="color"]',
  [...colors].sort(
    (a, b) =>
      (COLOR_FAMILY_ORDER.indexOf(a.toLowerCase()) === -1 ? 999 : COLOR_FAMILY_ORDER.indexOf(a.toLowerCase())) -
      (COLOR_FAMILY_ORDER.indexOf(b.toLowerCase()) === -1 ? 999 : COLOR_FAMILY_ORDER.indexOf(b.toLowerCase()))
  ),
  'color'
);

  getActiveFilterValues('tone').forEach(tone => {
  tones.add(tone);
});

fillMenu(
  '[data-fc-options="tone"]',
  [...tones].sort(
    (a, b) =>
      TONE_ORDER.indexOf(a.toLowerCase()) -
      TONE_ORDER.indexOf(b.toLowerCase())
  ),
  'tone'
);

  fillMenu(
    '[data-fc-options="size"]',
    [...sizes].sort(
      (a, b) =>
        KNOWN_SIZES.indexOf(a.toUpperCase()) -
        KNOWN_SIZES.indexOf(b.toUpperCase())
    ),
    'size'
  );

  fillMenu(
    '[data-fc-options="collection"]',
    [...collections].sort(),
    'collection'
  );

  syncGenreSubtypeRows();

  document
    .querySelectorAll('[data-fc-filter="textOnly"]')
    .forEach(button => {
      button.hidden = !hasTextOnly;
      button.classList.toggle('selected', activeFilters.textOnly);
    });

  document
    .querySelectorAll('[data-fc-filter="nsfw"]')
    .forEach(button => {
      button.hidden = !hasNsfw;
      button.classList.toggle('selected', activeFilters.nsfw);
    });

  document
    .querySelectorAll('[data-fc-filter="emoji"]')
    .forEach(button => {
      button.hidden = !hasEmoji;
      button.classList.toggle('selected', activeFilters.emoji);
    });

  document
    .querySelectorAll('[data-fc-filter-group="boolean"]')
    .forEach(group => {
      group.hidden =
        !hasTextOnly &&
        !hasNsfw &&
        !hasEmoji;
    });

  document
    .querySelectorAll('[data-fc-filter-group="collection"]')
    .forEach(group => {
      group.hidden = !hasCollections;
    });
};

  /* =========================================================
     MATCHING + APPLYING FILTERS
  ========================================================= */

    const matchesCard = card => {
    if (!queryMatchesCard(card)) return false;

        if (
      activeFilters.category &&
      getCategory(card) !== activeFilters.category
    ) {
      return false;
    }

    const activeGenre =
      activeFilters.genre || activeFilters.content;

    if (
      activeGenre &&
      !getContentTypes(card).includes(activeGenre)
    ) {
      return false;
    }

    for (const filter of getGenreSubtypeFilters()) {
      if (
        activeFilters[filter.key] &&
        !getSubtypeValues(card, filter.key).includes(activeFilters[filter.key])
      ) {
        return false;
      }
    }

    const selectedColors = getActiveFilterValues('color');
    const selectedTones = getActiveFilterValues('tone');

    if (selectedColors.length && selectedTones.length) {
  const pairs = getColorTonePairs(card);

  const hasPairedVariantMatch =
    pairs.length
      ? pairs.some(pair =>
          selectedColors.includes(pair.family) &&
          selectedTones.includes(pair.tone)
        )
      : getCardVariantMap(card).some(variant =>
          selectedColors.includes(getVariantFamily(variant)) &&
          selectedTones.includes(getVariantTone(variant))
        );

  if (!hasPairedVariantMatch) return false;
} else {
  if (
    selectedColors.length &&
    !selectedColors.some(color => getColorFamily(card).includes(color))
  ) {
    return false;
  }

  if (
    selectedTones.length &&
    !selectedTones.some(tone => getColorTone(card).includes(tone))
  ) {
    return false;
  }
}

    if (
      activeFilters.department &&
      !getDepartment(card).includes(activeFilters.department)
    ) {
      return false;
    }

    if (
      activeFilters.apparel &&
      !getApparel(card).includes(activeFilters.apparel)
    ) {
      return false;
    }

    if (
      activeFilters.fit &&
      !getFit(card).includes(activeFilters.fit)
    ) {
      return false;
    }

    if (
      activeFilters.aesthetic &&
      !getAesthetic(card).includes(activeFilters.aesthetic)
    ) {
      return false;
    }

    if (
      activeFilters.services &&
      !getServices(card).includes(activeFilters.services)
    ) {
      return false;
    }

    if (
      activeFilters.collection &&
      !getCollection(card).includes(activeFilters.collection)
    ) {
      return false;
    }

    if (
      activeFilters.textOnly &&
      !getTextOnly(card)
    ) {
      return false;
    }

    if (
      activeFilters.nsfw &&
      !getNsfw(card)
    ) {
      return false;
    }

    if (
      activeFilters.emoji &&
      !getEmoji(card)
    ) {
      return false;
    }

    if (
      activeFilters.size &&
      !getCardSizes(card).includes(activeFilters.size.toUpperCase())
    ) {
      return false;
    }

    return true;
  };


  const renderActivePills = () => {
    const container = document.querySelector('[data-fc-active-filters]');

    if (!container) return;

    const pills = [];

    if (activeFilters.query) {
      pills.push(['query', activeFilters.query, `Search: ${activeFilters.query}`]);
    }

    if (activeFilters.category) {
      pills.push(['category', activeFilters.category, labelize(activeFilters.category)]);
    }

    if (activeFilters.content) {
      pills.push(['content', activeFilters.content, labelize(activeFilters.content)]);
    }

    getGenreSubtypeFilters().forEach(filter => {
      if (activeFilters[filter.key]) {
        pills.push([
          filter.key,
          activeFilters[filter.key],
          labelize(activeFilters[filter.key])
        ]);
      }
    });

    if (activeFilters.department) {
      pills.push(['department', activeFilters.department, labelize(activeFilters.department)]);
    }

    if (activeFilters.apparel) {
      pills.push(['apparel', activeFilters.apparel, labelize(activeFilters.apparel)]);
    }

    if (activeFilters.fit) {
      pills.push(['fit', activeFilters.fit, labelize(activeFilters.fit)]);
    }

    if (activeFilters.aesthetic) {
      pills.push(['aesthetic', activeFilters.aesthetic, labelize(activeFilters.aesthetic)]);
    }

    if (activeFilters.services) {
      pills.push(['services', activeFilters.services, labelize(activeFilters.services)]);
    }

    getActiveFilterValues('color').forEach(color => {
      pills.push(['color', color, labelize(color)]);
    });

    getActiveFilterValues('tone').forEach(tone => {
      pills.push(['tone', tone, labelize(tone)]);
    });

    if (activeFilters.size) {
      pills.push(['size', activeFilters.size, activeFilters.size.toUpperCase()]);
    }

    if (activeFilters.collection) {
      pills.push(['collection', activeFilters.collection, labelize(activeFilters.collection)]);
    }

    if (activeFilters.textOnly) {
      pills.push(['textOnly', 'textOnly', 'Text Only']);
    }

    if (activeFilters.nsfw) {
      pills.push(['nsfw', 'nsfw', 'NSFW']);
    }

    if (activeFilters.emoji) {
      pills.push(['emoji', 'emoji', 'Emoji']);
    }

    if (!pills.length) {
      container.hidden = true;
      container.innerHTML = '';
      return;
    }

    container.hidden = false;

    container.innerHTML = pills
      .map(([key, value, label]) => `
        <button
          type="button"
          class="fc-active-filter-pill ${isColorToneSelectionTemporarilyUnavailable(key, value) ? 'fc-temporarily-unavailable' : ''}"
          data-fc-remove-filter="${key}"
          data-fc-remove-value="${value}"
        >
          <span>${label}</span>
          <span aria-hidden="true">×</span>
        </button>
      `)
      .join('');

    container.insertAdjacentHTML(
      'beforeend',
      `
        <button type="button" class="fc-active-filter-clear" data-fc-clear-all>
          Clear all
        </button>
      `
    );
  };


  const updateProductCount = () => {
  const visibleItems = Array.from(grid.querySelectorAll('.shop__grid-item'))
    .filter(item => !item.hidden && item.dataset.fcHidden !== 'true');

  const visibleCount = visibleItems.length;

  const filterCount =
    grid.dataset.collectionsCustomPrefetched === 'true'
      ? Array.from(
          new Set(
            getCards()
              .filter(card => matchesCard(card))
              .map(card => {
                const item = card.closest('.shop__grid-item');
                return getProductKey(item);
              })
              .filter(Boolean)
          )
        ).length
      : visibleCount;

  const countEls = document.querySelectorAll(
    '#ShopProductCount, .shop__product-count, .filters__results-count'
  );

  countEls.forEach(el => {
    if (el.classList.contains('filters__results-count')) {
      el.textContent = `(${filterCount} result${filterCount === 1 ? '' : 's'})`;
      return;
    }

    el.textContent = `${filterCount} product${filterCount === 1 ? '' : 's'}`;
  });

  if (visibleCount === 0) {
    const searchedQuery = activeFilters.query.trim();

    noResultsMessage.innerHTML = searchedQuery
      ? `
        <h2>Oopsie Doopsie!</h2>
        <p>No results found for “${searchedQuery}”. <br><br> Check the spelling, try another keyword, or reset filters to browse all products in this collection.</p>
      `
      : `
        <h2>Oopsie Doopsie!</h2>
        <p>No results found. <br><br> Check the spelling, try another keyword, or reset filters to browse all products in this collection.</p>
      `;
  }

  noResultsMessage.style.display =
    visibleCount === 0 ? 'block' : 'none';

  grid.style.display =
    visibleCount === 0 ? 'none' : '';
};

    const syncGenreSubtypeRows = () => {
  const activeGenre =
    activeFilters.genre || activeFilters.content;

  const hasGenreOptions =
    document.querySelector('[data-fc-options="genre"] .fc-filter-option') !== null ||
    document.querySelector('[data-fc-options="content"] .fc-filter-option') !== null;

  document
    .querySelectorAll('[data-fc-filter-group="content"]')
    .forEach(group => {
      group.hidden = !hasGenreOptions;
    });

  document
    .querySelectorAll('[data-fc-filter-group="genre"]')
    .forEach(group => {
      group.hidden = !hasGenreOptions;
    });

  getGenreSubtypeFilters().forEach(filter => {
    document
      .querySelectorAll(`[data-fc-filter-group="${filter.key}"]`)
      .forEach(group => {
        group.hidden = activeGenre !== filter.genre;
      });
  });
};

const sortVisibleCardsBySelectedColorOrder = () => {
  const selectedColors = getActiveFilterValues('color');
  const selectedTones = getActiveFilterValues('tone');

  if (!selectedColors.length) return;

  const visibleItems = Array.from(
    grid.querySelectorAll('.shop__grid-item')
  ).filter(item =>
    !item.hidden &&
    item.dataset.fcHidden !== 'true'
  );

  const getColorRank = item => {
    const card = item.querySelector('product-card');

    if (!card) return 999;

    const pairs = getColorTonePairs(card);

    if (selectedTones.length && pairs.length) {
      const matchingPair = pairs.find(pair =>
        selectedColors.includes(pair.family) &&
        selectedTones.includes(pair.tone)
      );

      if (matchingPair) {
        return selectedColors.indexOf(matchingPair.family);
      }
    }

    const families = getColorFamily(card);

    const matchingColor = selectedColors.find(color =>
      families.includes(color)
    );

    return matchingColor
      ? selectedColors.indexOf(matchingColor)
      : 999;
  };

  visibleItems
    .map((item, index) => ({
      item,
      index,
      rank: getColorRank(item)
    }))
    .sort((a, b) =>
      a.rank - b.rank ||
      a.index - b.index
    )
    .forEach(entry => {
      grid.appendChild(entry.item);
    });
};

  const applyFilters = () => {
  grid.dataset.fcApplyingFilters = 'true';
  clearInactiveGenreSubtypeFilters();

  const hasActiveFilters = hasActiveCollectionsFilter();

  document.querySelectorAll('.fc-filter-actions [data-fc-clear-all]').forEach(button => {
    button.textContent = hasActiveFilters ? 'Clear' : 'Close';
    button.dataset.fcMode = hasActiveFilters ? 'clear' : 'close';
  });

  const shouldUseFullPrefetchedSet =
  grid.dataset.collectionsCustomPrefetched === 'true';

const alreadyRenderedInitialKeys = new Set(
  Array.from(grid.querySelectorAll('.shop__grid-item'))
    .filter(item => item.dataset.fcPrefetched !== 'true')
    .map(item => getProductKey(item))
    .filter(Boolean)
);

getCards().forEach(card => {
  const item = card.closest('.shop__grid-item');

  if (!item) return;

  const productKey = getProductKey(item);
  const isPrefetched =
    item.dataset.fcPrefetched === 'true';

  const isMatch = matchesCard(card);

  if (!shouldUseFullPrefetchedSet && isPrefetched) {
    if (item.parentElement !== getPrefetchCache()) {
      getPrefetchCache().appendChild(item);
    }

    item.hidden = true;
    item.dataset.fcHidden = 'true';
    item.style.display = 'none';
    return;
  }

  if (
    shouldUseFullPrefetchedSet &&
    isPrefetched &&
    isMatch &&
    productKey &&
    alreadyRenderedInitialKeys.has(productKey)
  ) {
    getPrefetchCache().appendChild(item);
    item.hidden = true;
    item.dataset.fcHidden = 'true';
    item.style.display = 'none';
    return;
  }

  if (shouldUseFullPrefetchedSet && isPrefetched && isMatch) {
    grid.appendChild(item);
  }

  if (shouldUseFullPrefetchedSet && isPrefetched && !isMatch) {
    getPrefetchCache().appendChild(item);
  }

  item.hidden = !isMatch;
  item.dataset.fcHidden = isMatch ? 'false' : 'true';
  item.style.display = isMatch ? '' : 'none';
});

  sortVisibleCardsBySelectedColorOrder();

  buildCollectionsDynamicFilters();
  syncGenreSubtypeRows();
  updateProductCount();
  renderActivePills();

  requestAnimationFrame(() => {

    requestAnimationFrame(() => {
      grid.dataset.fcApplyingFilters = 'false';
    });
  });
};

  /* =========================================================
     SORTING
  ========================================================= */

  const sortCards = () => {
  let sorted = [...getCards()];

  if (!activeFilters.sort || activeFilters.sort === 'relevant') {
  sorted = [...getCards()];
}

    if (activeFilters.sort === 'title-ascending') {
      sorted.sort((a, b) => getTitle(a).localeCompare(getTitle(b)));
    }

    if (activeFilters.sort === 'title-descending') {
      sorted.sort((a, b) => getTitle(b).localeCompare(getTitle(a)));
    }

    if (activeFilters.sort === 'price-ascending') {
      sorted.sort((a, b) => getPrice(a) - getPrice(b));
    }

    if (activeFilters.sort === 'price-descending') {
      sorted.sort((a, b) => getPrice(b) - getPrice(a));
    }

    if (activeFilters.sort === 'created-descending') {
  sorted.sort((a, b) => {
    const itemA = a.closest('.shop__grid-item');
    const itemB = b.closest('.shop__grid-item');

    return Number(itemB?.dataset.date || 0) - Number(itemA?.dataset.date || 0);
  });
}

if (activeFilters.sort === 'created-ascending') {
  sorted.sort((a, b) => {
    const itemA = a.closest('.shop__grid-item');
    const itemB = b.closest('.shop__grid-item');

    return Number(itemA?.dataset.date || 0) - Number(itemB?.dataset.date || 0);
  });
}

    sorted.forEach(card => {
      const item = card.closest('.shop__grid-item');

      if (item) grid.appendChild(item);
    });
  };

  /* =========================================================
     DROPDOWN EVENTS
  ========================================================= */

  dropdowns.forEach(dropdown => {
    const key = dropdown.dataset.filterKey;
    const button =
  dropdown.querySelector('[data-collections-dropdown-button]') ||
  dropdown.querySelector('[data-filthy-dropdown-button]');

const menu =
  dropdown.querySelector('[data-collections-dropdown-menu]') ||
  dropdown.querySelector('[data-filthy-dropdown-menu]');
    const defaultLabel =
      dropdown
        .querySelector('[data-collections-dropdown-label], [data-filthy-dropdown-label]')
        ?.textContent
        ?.trim() || '';

    dropdown.dataset.defaultLabel = defaultLabel;

    if (menu) {
      menu.dataset.menuKey = key;
    }

    button?.addEventListener('click', event => {
      event.stopPropagation();

      const wasOpen = dropdown.classList.contains('is-open');

      closeDropdowns();

      if (!wasOpen) {
        dropdown.classList.add('is-open');

        if (menu && menu.parentElement !== document.body) {
          document.body.appendChild(menu);
        }

        positionMenu(dropdown, menu);
      }
    });

    menu?.addEventListener('click', event => {
      const option = event.target.closest('[data-value]');
      if (!option) return;

      event.stopPropagation();

      const value = option.dataset.value || '';
      const isAlreadySelected = activeFilters[key] === value;

      if (isAlreadySelected) {
        activeFilters[key] = '';
        setDropdownLabel(key, '', dropdown.dataset.defaultLabel);
      } else {
        activeFilters[key] = value;
        setDropdownLabel(key, value, option.textContent.trim());
      }

      closeDropdowns();

      if (key === 'sort') {
        sortCards();
      }

      buildCollectionsDynamicFilters();
      applyFilters();
    });
  });

  window.addEventListener(
    'scroll',
    () => {
      const openDropdown = dropdowns.find(dropdown =>
        dropdown.classList.contains('is-open')
      );

      if (!openDropdown) return;

     const menu =
  document.querySelector(
    `[data-collections-dropdown-menu][data-menu-key="${openDropdown.dataset.filterKey}"]`
  ) ||
  document.querySelector(
    `[data-filthy-dropdown-menu][data-menu-key="${openDropdown.dataset.filterKey}"]`
  );

      if (!menu) return;

      positionMenu(openDropdown, menu);
    },
    { passive: true }
  );

  document.addEventListener('click', closeDropdowns);

/* =========================================================
   SEARCH EVENTS
   Prevent native submit and filter products in-place
========================================================= */

let collectionsSearchTimeout = null;
let collectionsPrefetchPromise = null;

const waitForCollectionsPaint = () =>
  new Promise(resolve => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(resolve);
    });
  });

const waitForVisibleCollectionImages = async () => {
  const visibleImages = getItems()
    .filter(item => !item.hidden && item.dataset.fcHidden !== 'true')
    .flatMap(item => Array.from(item.querySelectorAll('img')));

  await Promise.race([
    Promise.all(
      visibleImages.map(img => {
        if (img.complete && img.naturalWidth > 0) return Promise.resolve();

        if (img.decode) {
          return img.decode().catch(() => {});
        }

        return new Promise(resolve => {
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', resolve, { once: true });
        });
      })
    ),
    new Promise(resolve => setTimeout(resolve, 900))
  ]);
};

const updateCollectionsResults = async ({ showLoader = true } = {}) => {
  if (showLoader) {
    document.body.classList.add('collections-custom-loading');
  }

  activeFilters.query =
    input.value.trim().toLowerCase();

  buildCollectionsDynamicFilters();
  applyFilters();

  await waitForCollectionsPaint();
  await waitForVisibleCollectionImages();
  await waitForCollectionsPaint();

  if (showLoader) {
    document.body.classList.remove(
      'collections-custom-loading',
      'collections-custom-initializing'
    );
  }

  if (!collectionsPrefetchPromise) {
    collectionsPrefetchPromise = prefetchRemainingCollectionProducts();
  }

  await collectionsPrefetchPromise;

  buildCollectionsDynamicFilters();
  applyFilters();

  if (activeFilters.sort) {
    sortCards();
  }
};

input.addEventListener('input', () => {
  clearTimeout(collectionsSearchTimeout);

  collectionsSearchTimeout =
    setTimeout(() => {
  updateCollectionsResults({ showLoader: false });
}, 20);
});

form.addEventListener('submit', event => {
  event.preventDefault();

  input.value = input.value.trim();

  updateCollectionsResults();
});

  /* =========================================================
     RESET EVENT
  ========================================================= */

    resetButton?.addEventListener('click', () => {
    activeFilters.query = '';
    activeFilters.category = '';
    activeFilters.content = '';
    activeFilters.genre = '';
    clearGenreSubtypeFilters();
    activeFilters.department = '';
    activeFilters.apparel = '';
    activeFilters.fit = '';
    activeFilters.aesthetic = '';
    activeFilters.services = '';
    activeFilters.color = [];
    activeFilters.tone = [];
    activeFilters.collection = '';
    activeFilters.textOnly = false;
    activeFilters.nsfw = false;
    activeFilters.emoji = false;
    activeFilters.size = '';
    activeFilters.sort = '';

    input.value = '';

    dropdowns.forEach(dropdown => {
      const key = dropdown.dataset.filterKey;
      const label = dropdown.dataset.defaultLabel;

      setDropdownLabel(key, '', label);
    });

    closeDropdowns();
    buildCollectionsDynamicFilters();
    applyFilters();
  });


  /* =========================================================
   MOBILE CLEAR/CLOSE PRESS STATE
========================================================= */

document.addEventListener('pointerdown', event => {
  if (event.pointerType === 'mouse') return;

  const clearButton =
    event.target.closest('[data-fc-clear-all]');

  if (!clearButton) return;

  clearButton.classList.add('is-pressing');
});

document.addEventListener('pointerup', event => {
  if (event.pointerType === 'mouse') return;

  const clearButton =
    event.target.closest('[data-fc-clear-all]');

  if (!clearButton) return;

  clearButton.classList.remove('is-pressing');
  clearButton.blur();
});

document.addEventListener('pointercancel', event => {
  if (event.pointerType === 'mouse') return;

  const clearButton =
    event.target.closest('[data-fc-clear-all]');

  if (!clearButton) return;

  clearButton.classList.remove('is-pressing');
  clearButton.blur();
});



  document.addEventListener('click', event => {
    const removeButton = event.target.closest('[data-fc-remove-filter]');

    if (!removeButton) return;

    event.preventDefault();

    const key = removeButton.dataset.fcRemoveFilter;

    if (!key) return;

    if (
  key === 'textOnly' ||
  key === 'nsfw' ||
  key === 'emoji'
) {
  activeFilters[key] = false;
} else if (key === 'color' || key === 'tone') {
  activeFilters[key] = getActiveFilterValues(key).filter(
    value => value !== normalizeColorFamilyValue(removeButton.dataset.fcRemoveValue || '')
  );
} else {
  activeFilters[key] = '';
}

    if (key === 'query') {
  activeFilters.query = '';
  input.value = '';

  updateCollectionsResults({ showLoader: false });
  return;
}


buildCollectionsDynamicFilters();
applyFilters();
  });



      document.addEventListener('click', event => {
    const clearButton = event.target.closest('[data-fc-clear-all]');

    if (!clearButton) return;

    event.preventDefault();


    if (clearButton.dataset.fcMode === 'close') {
      const sidebar =
        clearButton.closest('#SidebarFiltersMobile') ||
        clearButton.closest('#SidebarFiltersDesktop') ||
        clearButton.closest('sidebar-filters-mobile') ||
        clearButton.closest('sidebar-filters-desktop');

      const closeButton = sidebar?.querySelector('[data-sidebar-button]');
      closeButton?.click();

      return;
    }

    activeFilters.query = '';
    activeFilters.category = '';
    activeFilters.content = '';
    activeFilters.genre = '';
    clearGenreSubtypeFilters();
    activeFilters.department = '';
    activeFilters.apparel = '';
    activeFilters.fit = '';
    activeFilters.aesthetic = '';
    activeFilters.services = '';
    activeFilters.color = [];
    activeFilters.tone = [];
    activeFilters.collection = '';
    activeFilters.textOnly = false;
    activeFilters.nsfw = false;
    activeFilters.emoji = false;
    activeFilters.size = '';
    activeFilters.sort = '';

    input.value = '';

updateCollectionsResults({ showLoader: false });

clearButton.blur();
  });

  document.addEventListener('click', event => {
    const applyButton = event.target.closest('[data-fc-apply]');

    if (!applyButton) return;

    event.preventDefault();

    const sidebar = applyButton.closest(
      'sidebar-filters-desktop, sidebar-filters-mobile'
    );

    const closeButton = sidebar?.querySelector('[data-sidebar-button]');

    closeButton?.click();
  });


    /* =========================================================
   CUSTOM SORT EVENTS
========================================================= */

document.addEventListener('click', event => {
  const sortOption = event.target.closest('[data-fc-sort-option]');

  if (!sortOption) return;

  event.preventDefault();
  event.stopPropagation();

  const value = sortOption.dataset.fcSortValue || '';
  const label = sortOption.textContent.trim();

  activeFilters.sort = value;

  document
    .querySelectorAll('[data-fc-sort-option]')
    .forEach(option => {
      option.classList.toggle(
        'active',
        option.dataset.fcSortValue === value
      );
    });

  document
    .querySelectorAll('[data-fc-sort-label]')
    .forEach(labelEl => {
      labelEl.textContent = label;
    });

    applyFilters();
    sortCards();

  const sidebar = sortOption.closest('#SortListSidebar');
  const closeButton = sidebar?.querySelector('[data-sidebar-button]');

  setTimeout(() => {
    closeButton?.click();
  }, 80);

  const desktopDropdown = document.getElementById('SortList');
  desktopDropdown?.setAttribute('aria-hidden', 'true');
});



  /* =========================================================
     DRAWER FILTER EVENTS
  ========================================================= */

  document.addEventListener('click', event => {
  if (
    event.target.closest('[data-sidebar-id="SidebarFiltersDesktop"]') ||
    event.target.closest('[data-sidebar-id="SidebarFiltersMobile"]') ||
    event.target.closest('[data-sidebar-button]')
  ) {
    requestAnimationFrame(() => {
      if (grid.dataset.fcApplyingFilters === 'true') return;

      buildCollectionsDynamicFilters();
      syncGenreSubtypeRows();
      renderActivePills();
      updateProductCount();
    });
  }
});

      document.addEventListener('click', event => {
    const option = event.target.closest('.fc-filter-option');

    if (!option) return;

    event.preventDefault();
    event.stopPropagation();

    const key = option.dataset.fcFilter;
    const value = option.dataset.fcValue || '';

    if (!key) return;

    if (
      key === 'textOnly' ||
      key === 'nsfw' ||
      key === 'emoji'
    ) {
      activeFilters[key] = !activeFilters[key];

      option.classList.toggle(
        'selected',
        activeFilters[key]
      );
        } else {
        toggleActiveFilterValue(key, value);
      }

    if (key === 'category') {
      activeFilters.content = '';
      activeFilters.genre = '';
      clearGenreSubtypeFilters();
      activeFilters.department = '';
      activeFilters.apparel = '';
      activeFilters.fit = '';
      activeFilters.aesthetic = '';
      activeFilters.services = '';
    }

    if (key === 'content' || key === 'genre') {
      clearInactiveGenreSubtypeFilters();
    }

    if (key === 'department' || key === 'apparel' || key === 'fit') {
      activeFilters.services = '';
    }

    if (key === 'services') {
      activeFilters.department = '';
      activeFilters.apparel = '';
      activeFilters.fit = '';
    }

    buildCollectionsDynamicFilters();
    applyFilters();
  });

  /* =========================================================
   PREFETCH REMAINING COLLECTION PRODUCTS
========================================================= */

const prefetchRemainingCollectionProducts = async () => {
  if (grid.dataset.collectionsCustomPrefetching === 'true') return;
  if (grid.dataset.collectionsCustomPrefetched === 'true') return;

  grid.dataset.collectionsCustomPrefetching = 'true';

  const cache = getPrefetchCache();

  try {
    let page = 2;
    let safety = 0;

    while (safety < 20) {
      safety++;

      const params = new URLSearchParams(window.location.search);
      params.set('page', page.toString());

      const pageUrl =
        `${window.location.pathname}?${params.toString()}`;

      const response = await fetch(pageUrl);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const incomingItems = Array.from(
        doc.querySelectorAll('#ShopProductsGrid .shop__grid-item')
      );

      if (!incomingItems.length) {
        break;
      }

      const existingKeys = new Set(
        getItems().map(item => getProductKey(item)).filter(Boolean)
      );

      let addedCount = 0;

      incomingItems.forEach(item => {
        const key = getProductKey(item);

        if (!key || existingKeys.has(key)) return;

        item.hidden = true;
        item.dataset.fcHidden = 'true';
        item.dataset.fcPrefetched = 'true';
        item.style.display = 'none';

        cache.appendChild(item);
        existingKeys.add(key);
        addedCount++;
      });

      if (addedCount === 0) {
        break;
      }

      page++;
    }

    grid.dataset.collectionsCustomPrefetched = 'true';
  } catch (error) {
    console.error(error);
  } finally {
    grid.dataset.collectionsCustomPrefetching = 'false';
  }
};


/*
  Collections Custom Search uses its own prefetch cache.

  This observer handles theme/native pagination additions.
  It removes duplicate product cards immediately and only filters true new cards.
*/

let externalGridMutationTimeout = null;

const collectionsGridObserver = new MutationObserver(mutations => {
  if (grid.dataset.fcApplyingFilters === 'true') return;

  const addedItems = [];

  mutations.forEach(mutation => {
    Array.from(mutation.addedNodes).forEach(node => {
      if (node.nodeType !== 1) return;

      if (node.matches?.('.shop__grid-item')) {
        addedItems.push(node);
        return;
      }

      node
        .querySelectorAll?.('.shop__grid-item')
        .forEach(item => addedItems.push(item));
    });
  });

  if (!addedItems.length) return;

  addedItems.forEach(item => {
    const key = getProductKey(item);

    if (!key) return;

    const duplicateAlreadyExists = getItems().some(existingItem =>
      existingItem !== item &&
      getProductKey(existingItem) === key
    );

    if (duplicateAlreadyExists) {
      item.remove();
      return;
    }

    const card = item.querySelector('product-card');

    if (!card) return;

    const isMatch = matchesCard(card);

    item.hidden = !isMatch;
    item.dataset.fcHidden = isMatch ? 'false' : 'true';
    item.style.display = isMatch ? '' : 'none';
  });

  clearTimeout(externalGridMutationTimeout);

  externalGridMutationTimeout = setTimeout(() => {
    if (grid.dataset.fcApplyingFilters === 'true') return;

    buildCollectionsDynamicFilters();
    updateProductCount();
    renderActivePills();
  }, 0);
});

collectionsGridObserver.observe(grid, {
  childList: true
});

     /* =========================================================
     INITIALIZE
     Read header handoff query from URL
  ========================================================= */

const initialParams =
  new URLSearchParams(window.location.search);

const initialQuery =
  (initialParams.get('q') || '').trim();

if (initialQuery) {
  input.value = initialQuery;
}

activeFilters.query =
  input.value.trim().toLowerCase();

updateCollectionsResults();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionsCustomSearch, { once: true });
} else {
  initCollectionsCustomSearch();
}
})();
